import { CSSProperties, ReactNode } from "react";



interface ContextualTooltipProps {
    visible?: boolean
    tooltipData: { ev: React.MouseEvent, customData?: any }
    children: ReactNode
}


export function ContextualTooltip({
    visible,
    tooltipData,
    children
}: ContextualTooltipProps) {



    const { ev } = tooltipData ?? null

    const cursorPosition = { horizontal: ev?.clientX, vertical: ev?.clientY }
    const customData = tooltipData?.customData

    const style: CSSProperties = {
        position: "absolute",
        zIndex: "9999",

        backgroundColor: "#d3d3d344",
        border: "1px solid grey",
        display: visible ? "grid" : "none",
        gap: "0.5em",
        padding: "1em",
        gridTemplateColumns: "1fr",
        placeItems: "center",
        top: `${cursorPosition?.vertical ?? "4em"}`,
        left: `${cursorPosition?.horizontal ?? "12em"}`,
    }

    return (
        <div style={style}  >
            <p>{JSON.stringify(customData)} </p>
                {children}
        </div>)

}
